import { qualifyUrl } from "util/URLUtils";
export const REPORT_TZ_FALLBACK = "UTC";
export const SOURCE_URL = "/plugins/org.graylog.plugins.report";
export const reportingUrl = (path) => {
  const effectivePath = path ? `${SOURCE_URL}/reports/${path}` : `${SOURCE_URL}/reports`;
  return qualifyUrl(effectivePath);
};
export const NEW_REPORT_DEFAULTS = Object.freeze({
  title: "",
  subtitle: "",
  description: "",
  widgets: [],
  positions: [],
  timezone: void 0,
  parameterValues: {},
  hideWidgetQuery: false,
  hideWidgetDescription: false,
  delivery: void 0,
  layout: void 0
});
export const reportWidgetHeaderId = (dashboardId, widgetId) => `widget-header-${dashboardId}-${widgetId}`;
export const MAX_LOGO_SIZE = 1024 * 1024;
export const DEFAULT_ORIENTATION = "portrait";
export const DEFAULT_SIZE = "letter";
export const WIDGET_ASPECT_RATIO = { portrait: 9 / 23, landscape: 1 / 3 };
export const WIDGET_MAX_HEIGHT_ASPECT_RATIO = {
  portrait: 2 * WIDGET_ASPECT_RATIO.portrait,
  landscape: 1.5 * WIDGET_ASPECT_RATIO.landscape
};
export const WIDGET_WIDTH = { landscape: 1400, portrait: 1100 };
export const MIN_WIDGET_HEIGHT = 200;
export const PAGE_PRINT_MARGIN_IN = 0.3;
export const PAGE_PRINT_MARGIN_PX = 96 * PAGE_PRINT_MARGIN_IN;
export const PAGE_PRINT_MARGIN = `${PAGE_PRINT_MARGIN_IN}in`;
export const PAGE_PRINT_MARGIN_LARGE = "0.7in";
export const PAGE_SIZES = [
  {
    label: "A4",
    value: "a4",
    portraitDimensions: { width: 816, height: 1056 },
    previewLayoutMultiplier: { portrait: 1.45, landscape: 1.39 }
  },
  {
    label: "US Letter",
    value: "letter",
    portraitDimensions: { width: 794, height: 1123 },
    previewLayoutMultiplier: { portrait: 1.494, landscape: 1.315 }
  }
];
export const PAGE_SIZES_MAP = Object.fromEntries(PAGE_SIZES.map((pageSize) => [pageSize.value, pageSize]));
export const getReportTableElements = (pluggableAttributes) => {
  const KEY_PREFIX = ["reports", "overview"];
  const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
  const tableLayout = {
    entityTableId: "reports",
    defaultPageSize: 20,
    defaultDisplayedAttributes: [
      "title",
      "subtitle",
      "description",
      "owner_full_name",
      "created_at",
      "last_generated_at",
      "status",
      "recipients"
    ],
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultColumnOrder: [
      "title",
      "subtitle",
      "description",
      "owner_full_name",
      "created_at",
      "timezone",
      "last_generated_at",
      "status",
      "recipients",
      ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) || []
    ]
  };
  const additionalAttributes = [
    { id: "recipients", title: "Recipients", sortable: false },
    ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributes) || []
  ];
  const fetchOptions = { refetchInterval: 5e3 };
  return {
    keyFn,
    tableLayout,
    additionalAttributes,
    fetchOptions
  };
};
